import defaultSettings from "../settings.json";
export interface GlobalState {
  settings?: typeof defaultSettings;
  userInfo?: {
    name?: string;
    avatar?: string;
    job?: string;
    organization?: string;
    location?: string;
    email?: string;
    permissions?: Record<string, string[]>;
    roles?: string[];
    authorities?: string[];
    [key: string]: any;
  };
  userLoading?: boolean;
  menus?: any[];
  menuLoading?: boolean;
}

const initialState: GlobalState = {
  settings: defaultSettings,
  userInfo: {
    permissions: {},
  },
  menus: [],
  menuLoading: false,
  userLoading: true,
};

export default function store(state = initialState, action) {
  switch (action.type) {
    case "update-settings": {
      const { settings } = action.payload;
      return {
        ...state,
        settings,
      };
    }
    case "update-userInfo": {
      const { userInfo = initialState.userInfo, userLoading } = action.payload;
      return {
        ...state,
        userLoading,
        userInfo,
      };
    }
    case "update-menus": {
      const { menus = initialState.menus, menuLoading } = action.payload;
      return {
        ...state,
        menus,
        menuLoading,
      };
    }
    default:
      return state;
  }
}
